/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @next/next/no-img-element */
import React from "react";
import moment from "moment";
import {
  CELEBRATION_TYPES,
  MESSAGE_TYPES,
  PROFILE_PICS,
} from "@buddieshr/utils/constants";
import { getPluralListOfElement } from "@buddieshr/utils/utils";
import { SlackAlias } from "./slackAlias";
import { useTranslation } from "react-i18next";
import styles from "@buddieshr/styles/components/slackPreview.module.scss";
import Image from "next/image";

export default function SlackMessagePreview({
  names = [],
  version = "v2",
  celebrationType = CELEBRATION_TYPES.BIRTHDAYS,
  app,
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.Slack_preview_wrapper}>
      <div className={styles.Slack_preview_sidebar}></div>
      <div className={styles.Slack_preview_main}>
        <div className={styles.Slack_preview}>
          <div className={styles.Slack_preview_inner}>
            <div className={styles.Slack_preview_picture_wrapper}>
              <Image
                width={50}
                height={50}
                src={app.logoUrl}
                className={styles.Slack_preview_picture}
                alt="logo billy birthday"
              />
            </div>
            <div>
              <div className={styles.Slack_preview_name_wrapper}>
                <div className={styles.Slack_preview_name}>
                  Billy (The Birthday Bot)
                </div>
                <div className={styles.Slack_preview_app}>APP</div>
                <div className={styles.Slack_preview_time}>9:00 AM</div>
              </div>
              {version === MESSAGE_TYPES.v1 ? (
                <div className={styles.Slack_preview_content}>
                  {t("whoop")}
                  <br />
                  {t("todayWeAre")}
                  {getPluralListOfElement(names)}'s{" "}
                  {celebrationType === CELEBRATION_TYPES.BIRTHDAYS
                    ? `birthday${(names || []).length > 1 ? "s" : ""}`
                    : `work anniversar${
                        (names || []).length > 1 ? "ies" : "y"
                      }`}
                  !<br />
                  {t("msgOutro")}
                </div>
              ) : (
                <div className={styles.Slack_preview_content}>
                  <div className={styles.Slack_preview_v2_title}>
                    {t("whoop")}
                  </div>
                  <div className={styles.Slack_preview_v2_subtitle}>
                    {t("todayWeAre")} {(names || []).length}{" "}
                    {celebrationType === CELEBRATION_TYPES.BIRTHDAYS
                      ? `birthday${(names || []).length > 1 ? "s" : ""}`
                      : `work anniversar${
                          (names || []).length > 1 ? "ies" : "y"
                        }`}
                    :
                  </div>
                  {(names || []).map((name, index) => (
                    <div
                      key={`${name}_${index}`}
                      className={`${styles.Slack_preview_v2_name} ${
                        index === (names || []).length - 1
                          ? styles.noBottom
                          : ""
                      }`}
                    >
                      <div className={styles.Slack_preview_v2_name_left}>
                        <div>
                          <SlackAlias name={name} />
                        </div>
                        <div className={styles.Slack_preview_v2_type}>
                          {celebrationType === CELEBRATION_TYPES.BIRTHDAYS
                            ? `${t("birthday")} 🎂`
                            : `${t("workAnniversary")} 💼`}
                        </div>
                        <div className={styles.Slack_preview_v2_date}>
                          {moment().format("MMM, DD")}
                        </div>
                      </div>
                      <div className={styles.Slack_preview_v2_name_right}>
                        <Image
                          width={50}
                          height={50}
                          src={PROFILE_PICS[index]}
                          alt="Birthday celebration"
                          style={{ height: "auto" }}
                        />
                      </div>
                    </div>
                  ))}
                  <div>------</div>
                  <div style={{ fontStyle: "italic" }}>
                    Time to send some positive vibes 🏄‍♂️
                  </div>
                </div>
              )}
              <div style={{ marginTop: "14px" }}>
                <Image
                  width={342}
                  height={30}
                  className={styles.Preview_reactions}
                  src="/img/apps/billy/reactions.png"
                  alt="reactions birthday bot"
                  style={{ marginLeft: "-4px" }}
                />
              </div>
              <div>
                <Image
                  width={232}
                  height={51}
                  className={styles.Preview_reactions}
                  src="/img/apps/billy/replies.png"
                  alt="reactions birthday bot"
                  style={{ marginLeft: "-4px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
